<template lang="pug">
  ul.social-networks
    li.social-networks__item(
      v-for="link in links"
    )
      a(
      target="_blank"
      v-bind:href="link.url"
      )
        img(
        v-if="mode === 'white'"
        :src="link.icon"
        :alt="link.alt"
        )
        img(
        v-else-if="mode === 'dark'"
        :src="link.iconDark"
        :alt="link.alt"
        )
</template>

<script>
export default {
  name: "social-networks",
  props: {
    mode: {
      // white, dark
      type: String,
      default: "white",
    },
  },
  data() {
    return {
      links: [
        {
          alt: "VK",
          url: "https://vk.com/minmol_rt",
          icon: require("@/assets/images/icons/sn-vk.svg"),
          iconDark: require("@/assets/images/icons/sn-vk-dark.svg"),
        },
        {
          alt: "Facebook",
          url: "https://www.facebook.com/minmol.rt/",
          icon: require("@/assets/images/icons/sn-fb.svg"),
          iconDark: require("@/assets/images/icons/sn-fb-dark.svg"),
        },
        {
          alt: "Twitter",
          url: "https://twitter.com/minmol_rt",
          icon: require("@/assets/images/icons/sn-tw.svg"),
          iconDark: require("@/assets/images/icons/sn-tw-dark.svg"),
        },
        {
          alt: "Instagram",
          url: "https://www.instagram.com/minmol_rt/",
          icon: require("@/assets/images/icons/sn-inst.svg"),
          iconDark: require("@/assets/images/icons/sn-inst-dark.svg"),
        },
      ],
    };
  },
};
</script>
